import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Ny handlingslista", -1)
const _hoisted_3 = { class: "form-group mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "shopping-list-name" }, "Namn:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Skapa")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "row",
  id: "shopping-list-wrapper"
}
const _hoisted_7 = { class: "table table-striped table-hover mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Vara"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Mängd"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Kommentar till butiken"),
      /*#__PURE__*/_createElementVNode("span", { class: "d-block d-md-none" }, "Kommentar")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
      class: "btn btn-link"
    }, " ← Tillbaka "),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.createNewShoppingList()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "shopping-list-name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shoppingListName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.shoppingListName]
          ])
        ]),
        _hoisted_5
      ], 32)
    ]),
    (_ctx.sourceShoppingList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceShoppingList.rows, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(row.text), 1),
                  _createElementVNode("td", null, _toDisplayString(row.amount), 1),
                  _createElementVNode("td", null, _toDisplayString(row.comment), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}